import { Component, Inject, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-salary-adjustment-dialog',
  templateUrl: './salary-adjustment-dialog.component.html',
  styleUrls: ['./salary-adjustment-dialog.component.less']
})

export class SalaryAdjustmentDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  public Math = Math;

  nowLoading = true;

  userName = this.data['userName'];

  // 定期の警告がある契約の「物件名（理由）」（一覧から受け取る。あれば上に知らせを出す。申請は止めない）
  fareMonthWarnings: string[] = this.data['fareMonthWarnings'] || [];

  // 申請内容
  salaryAdjust = {
    yearMonth: this.data['yearMonth'],
    staffDailyCleaning: this.data['staffDailyCleaning'],

    // 申請する勤務金額
    appliedFare: this.data['appliedFare'],
    // 申請する交通費
    appliedWorkBasic: this.data['appliedWorkBasic'],
    // 申請する有休の差額分（有休は差額を申請）
    diffPaidHoliday: this.data['diffPaidHoliday'],

    id: null,

    adjustStatus: null,

    applicantNote: null,
    applicantName: null,
    applicantId: null,
    applicantDate: null,

    rejectNote: null,
    approverName: null,
    approverId: null,
    approverDate: null,

    applicantOldNote: null,

    color: ''
  }

  // 実働金額の差異
  diffWorkBasic = 0

  // 交通費の差異
  diffFare = 0

  // 変更後の有休
  totalPh = 0

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SalaryAdjustmentDialogComponent>,) { }

  ngOnInit() {
    this.getData();
  }

  /**
   * 表示する情報を取得
   */
  getData() {
    this.nowLoading = true
    this.http.get(
      API_BASE_URL + '/api/v1/salary/appAdjust?yearMonth='+ this.data['yearMonth'] + "&staffCd=" + Number(this.data['staffDailyCleaning']),
      {headers: this.headers}
    )
    .subscribe((res: any) => {
      // 申請済みデータ
      if (res) {
        this.salaryAdjust.id = res.id
        this.salaryAdjust.adjustStatus = res.adjustStatus
        this.salaryAdjust.applicantName = res.applicantName
        this.salaryAdjust.applicantId = res.applicantId
        this.salaryAdjust.applicantDate = res.applicantDate
        this.salaryAdjust.rejectNote = res.rejectNote
        this.salaryAdjust.approverName = res.approverName
        this.salaryAdjust.approverId = res.approverId
        this.salaryAdjust.approverDate = res.approverDate
        this.salaryAdjust.applicantOldNote = res.applicantOldNote

        if (res.adjustStatus != '承認') {
          this.salaryAdjust.applicantNote = res.applicantNote
        }

        if ((this.salaryAdjust.adjustStatus || this.data['adjustStatus']) && this.salaryAdjust.adjustStatus != this.data['adjustStatus']) {
          alert('先ほどの一覧のデータが古い可能性があります。一覧に戻ります。再度、金額調整ボタンを押してください。')
          this.dialogRef.close(true);
          return
        }

        if (this.salaryAdjust.adjustStatus == '承認') {
          this.salaryAdjust.color = 'app'
        } else if (this.salaryAdjust.adjustStatus == '差戻') {
          this.salaryAdjust.color = 'ng'
        } else if (this.salaryAdjust.adjustStatus == '申請中') {
          this.salaryAdjust.color = 'pnd'
        }
      }

      this.calc()
      this.nowLoading = false
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 金額の差異を計算
   */
  calc() {
    // 実働金額
    if (this.salaryAdjust.appliedWorkBasic != null) {
      this.diffWorkBasic = Number(this.salaryAdjust.appliedWorkBasic) - Number(this.data['workBasic'])
    } else {
      this.diffWorkBasic = 0
    }
    
    // 交通費
    if (this.salaryAdjust.appliedFare != null) {
      this.diffFare = Number(this.salaryAdjust.appliedFare) - Number(this.data['fare'])
    } else {
      this.diffFare = 0
    }

    // 有休
    if (this.salaryAdjust.diffPaidHoliday) {
      this.totalPh = Number(this.data['totalPhBasicNoChange']) + Number(this.salaryAdjust.diffPaidHoliday)
    } else {
      this.totalPh = 0
    }
  }

  /**
   * キャンセルボタン
   */
  cancel() {
    this.dialogRef.close();
  }

  /**
   * 申請取消ボタン
   */
  remove() {
    if (!window.confirm('この申請を取消してよろしいでしょうか？')) {
      return
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.nowLoading = true

    this.salaryAdjust.applicantId = localStorage.getItem("uid")
    this.salaryAdjust.applicantName = this.userName

    this.http.post(
        API_BASE_URL + '/api/v1/salary/removeSalaryAdjust?staff=' + this.data['staff'],
          this.salaryAdjust,
          httpOptions
      ).subscribe(async res => {
        this.dialogRef.close(true);
        this.nowLoading = false;
      },error => {
        alert("エラーが発生したため取消できませんでした。");
        this.nowLoading = false;
      });
  }

  /**
   * 申請ボタン
   */
  save() {
    if (this.salaryAdjust.adjustStatus != '差戻' && this.salaryAdjust.appliedWorkBasic == this.data['appliedWorkBasic'] && this.salaryAdjust.appliedFare == this.data['appliedFare'] && this.salaryAdjust.diffPaidHoliday == this.data['diffPaidHoliday']) {
      alert('金額が変更されていません。')
      return
    }
    if (!this.salaryAdjust['applicantNote']) {
      alert('申請理由をご記入ください。')
      return
    }
    if (Number(this.salaryAdjust.appliedWorkBasic) >= 500000) {
      alert('勤務金額が50万以上のため、申請できません。')
      return
    }
    if (Number(this.salaryAdjust.appliedFare) >= 100000) {
      alert('交通費が10万以上のため、申請できません。')
      return
    }
    if (this.totalPh >= 500000) {
      alert('有休金額が50万以上のため、申請できません。')
      return
    }

    if (this.salaryAdjust['id']) {
      if (this.salaryAdjust.adjustStatus == '承認') {
        if (!window.confirm('すでに承認されています。再申請を行いますか？')) {
          return
        }
      }
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.nowLoading = true

    this.salaryAdjust.adjustStatus = '申請中'
    this.salaryAdjust.applicantId = localStorage.getItem("uid")
    this.salaryAdjust.applicantName = this.userName

    this.http.post(
        API_BASE_URL + '/api/v1/salary/appliSalaryAdjust?staff=' + this.data['staff'],
          { salaryAdjust: this.salaryAdjust, salary: this.data },
          httpOptions
      ).subscribe(res => {
        this.dialogRef.close(true);
      },error => {
        alert("エラーが発生したため保存できませんでした。再度登録をお願いします。");
        console.log(error)
        this.nowLoading = false;
      });
  }
}


